import {Component, Input, OnInit} from '@angular/core';
import {UrlBuilder} from "./url-builder/url.builder";
import {AuthService} from "@auth0/auth0-angular";
import {environment} from "../environments/environment";
import {ClientListWithAccess} from "./listclients/clientlistwithaccess";
import {SwUpdate} from "@angular/service-worker";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  @Input()
  selectedClient: string = "SClocalhost";
  title = 'Serviceweb' + this.selectedClient;
  url: UrlBuilder;
  authEnabled: boolean = true;

  constructor(public auth: AuthService, private swUpdate: SwUpdate) {
    this.url = new UrlBuilder();
    this.url.SetCurrentClient(this.selectedClient);
    console.log('SELECTED CLIENT: ' + this.selectedClient);
  }

  onActivate(): void {
    window.scroll(0, 0);
  }

  ngOnInit() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.available.subscribe(() => {
        if(confirm("New version available. Load New Version?")) {
          window.location.reload();
        }
      });
    }

    this.authEnabled = environment.production;
    if (this.authEnabled) {
      this.auth.user$.subscribe(
        (profile) => {
          if (profile) {
            console.log("WEB:", profile);
            this.url.SetIdToken(profile['https://DSC400.nl']['monitor']);
            ClientListWithAccess.SetAccessListByToken(profile['https://DSC400.nl']['monitorlist']);
            ClientListWithAccess.SetAccessList(profile['https://DSC400.nl']['rawclimate']);
          }
        }
      );
    }

  }
}
